import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { GcContentCalc } from "../components/GcContentCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.gc_tool_name()}
        toolPath="/gc-content"
      />
      <SciHeader title={m.gc_h1()} intro={m.gc_intro()} />

      <GcContentCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.gc_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.gc_ex1(), m.gc_ex2(), m.gc_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.gc_faq_q1(), a: m.gc_faq_a1() },
          { q: m.gc_faq_q2(), a: m.gc_faq_a2() },
          { q: m.gc_faq_q3(), a: m.gc_faq_a3() },
          { q: m.gc_faq_q4(), a: m.gc_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
